import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText, FormHelperText } from '@mui/material';
import { useController, Control } from 'react-hook-form';

type Props = {
    name: string;
    control: Control<any>;
    label?: string;
    disabled?: boolean;
};

const DAYS = [
    { label: 'Sunday', value: 'sunday' },
    { label: 'Monday', value: 'monday' },
    { label: 'Tuesday', value: 'tuesday' },
    { label: 'Wednesday', value: 'wednesday' },
    { label: 'Thursday', value: 'thursday' },
    { label: 'Friday', value: 'friday' },
    { label: 'Saturday', value: 'saturday' },
];

const CustomMultiSelect: React.FC<Props> = ({ name, control, label = 'Select', disabled = false }) => {
    const { field, fieldState } = useController({ name, control });

    const handleChange = (event: any) => {
        const value = event.target.value;
        // Ensure value is always an array (MUI may return string when single)
        field.onChange(Array.isArray(value) ? value : [value]);
    };

    return (
        <FormControl fullWidth error={!!fieldState?.error}>
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <Select
                labelId={`${name}-label`}
                multiple
                value={field.value || []}
                onChange={handleChange}
                label={label}
                renderValue={(selected) => (selected as string[]).map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(', ')}
                disabled={disabled}
            >
                {DAYS.map(day => (
                    <MenuItem key={day.value} value={day.value}>
                        <Checkbox checked={Array.isArray(field.value) ? field.value.indexOf(day.value) > -1 : false} />
                        <ListItemText primary={day.label} />
                    </MenuItem>
                ))}
            </Select>
            {fieldState?.error && <FormHelperText>{fieldState.error?.message}</FormHelperText>}
        </FormControl>
    );
};

export default CustomMultiSelect;
